import FooterLegal from '~/src/screens/App/Footer/FooterLegal';
import ReinsuranceBanner from '~/src/screens/App/Footer/ReinsuranceBanner';

import styles from './Footer.module.scss';
import { AllLinksPart } from './layout';
import AboutSection from './Sections/AboutSection';
import CategoriesSection from './Sections/CategoriesSection';
import ContactUsSection from './Sections/ContactUsSection';
import RatingsAndDownloadAppsSection from './Sections/RatingsAndDownloadAppsSection';

interface Props {
  hasOrderStatus?: boolean;
}

const Footer = ({ hasOrderStatus }: Props) => {
  return (
    <footer className={styles.container} id="footer">
      <ReinsuranceBanner />
      <AllLinksPart>
        <CategoriesSection />
        <AboutSection />
        <ContactUsSection />
        <RatingsAndDownloadAppsSection />
      </AllLinksPart>
      <FooterLegal hasOrderStatus={hasOrderStatus} />
    </footer>
  );
};

export default Footer;
